/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface ContributionRequest {

    /**
     * Uuid of this contribution
     */
    uuid?: string;

    /**
     * Email if the donor is not a registered user
     */
    email?: string;

    /**
     * Uuid of the user contributer
     */
    user_uuid?: string;

    /**
     * Where the contribution originated
     */
    platform_name?: string;

    /**
     * Payment provider where the contribution was purchased
     */
    gateway_name?: string;

    /**
     * When the contribution was purchased
     */
    purchased_at?: string;

    /**
     * Amount of donation, in cents
     */
    amount?: number;

    /**
     * Uuid of the chosen contribution offer set
     */
    offer_set_uuid?: string;

    /**
     * Number of months of membership access granted by this contribution
     */
    entitlement_periods?: number;

}

@Model('Contribution')
export class ApiContribution extends BaseModel implements ContributionRequest {

    /**
     * Uuid of this contribution
     */
    
    
    uuid: string;

    /**
     * Email if the donor is not a registered user
     */
    
    
    email: string;

    /**
     * Uuid of the user contributer
     */
    
    
    user_uuid: string;

    /**
     * Where the contribution originated
     */
    
    
    platform_name: string;

    /**
     * Payment provider where the contribution was purchased
     */
    
    
    gateway_name: string;

    /**
     * When the contribution was purchased
     */
    
    
    purchased_at: string;

    /**
     * Amount of donation, in cents
     */
    
    
    amount: number;

    /**
     * Uuid of the chosen contribution offer set
     */
    
    
    offer_set_uuid: string;

    /**
     * Number of months of membership access granted by this contribution
     */
    
    
    entitlement_periods: number;

}
